import React, { useState, useEffect } from "react";
import styles from "../../Components/Table/TableV2.module.css";
import Checkbox from "@mui/material/Checkbox";
import { useMsal } from "@azure/msal-react";
import { VariantType, useSnackbar } from "notistack";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
// import "./invoice.css";
import { useSelector, useDispatch } from "../../redux/store";
import { setDefaultBillPayer } from "../../redux/slices/projectBilling";

const BillPayerTable = ({
  jobNumber,
  jsonData,
  headerMap = {},
  clickableRowAdd = false,
  handleRowEdit,
  // setRowData,
  rowD,
  disabled = false,
}) => {
  const { accounts } = useMsal();
  const account = accounts[0];
  const { enqueueSnackbar } = useSnackbar();
  // const { isSubmitting, raiseInvoiceAssignedBilling } = useSelector(
  //   (state) => state.raiseInvoice
  // );
  const [rowData, setRowData] = useState([]);
  const dispatch = useDispatch();
  // useEffect(() => {

  //   if (raiseInvoiceAssignedBilling.length > 0) {
  //     const data = raiseInvoiceAssignedBilling
  //     setRowData(data);
  //   }
  // }, [raiseInvoiceAssignedBilling]);

  useEffect(() => {
    setRowData(rowD);
  }, []);
  const resolvedHeaderMap = headerMap;
  const headers = Object.keys(resolvedHeaderMap).map(
    (key) => resolvedHeaderMap[key] || key
  );

  const handleRowUpdate = (key, comingRow, value) => {
    const updatedRows = [...rowData];
    setRowData(
      updatedRows.map((item) => {
        if (item.billPayerID === comingRow.billPayerID) {
          return { ...item, [key]: value };
        } else {
          return { ...item, [key]: false };
        }
      })
    );

    postDefaultBillPayer(comingRow.billPayerID);
  };

  const postDefaultBillPayer = async (billPayerID) => {
    const body = {
      billPayerID: billPayerID,
      jobNumber: jobNumber,
      updatedBy: account.username,
    };
    try {
      const result = await dispatch(setDefaultBillPayer({ body })).unwrap();
      if (result.success) {
        enqueueSnackbar("Request completed successfully!", {
          variant: "success",
        });
      } else {
        enqueueSnackbar("Error in updating  Bill payer!", {
          variant: "success",
        });
      }

    } catch (error) {
      console.error("Error fetching project data:", error);
    }
  };

  const rowClasses = `${styles.tableRow} ${clickableRowAdd ? styles.rowHoverHighlight : ""
    }`;

  return (
    <div
      className={styles.tableContainer}
      style={{
        maxHeight: "300px",
        overflowY: "auto",
        background: "inherit",
      }}
    >
      <table className={styles.table}>
        <thead>
          <tr className={styles.tableHeader}>
            {headers?.map((header, index) => {
              // Determine the sorting arrow
              let arrow = "";

              // if (index === 0) {
              //   return <th className={styles.th} colspan="1"></th>;
              // }
              if (
                index == 2 ||
                index == 4 ||
                index == 3 ||
                index == 4 ||
                index == 5 ||
                index == 6 ||
                index == 7
              ) {
                return (
                  <th key={index} className={styles.th}>
                    <div
                      className={styles.CenterContent}
                    //   onClick={() => sortRows(index)}
                    >
                      {header}
                      {arrow}
                    </div>
                  </th>
                );
              }

              return (
                <th key={index} className={styles.th}>
                  <div>
                    {header}
                    {arrow}
                  </div>
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody className={styles.tbody}>
          {
            !Array.isArray(rowData) || rowData.length === 0 ?
              <tr
                className={rowClasses}
                style={{ background: "white" }}
              >
                <td colSpan={5} className={styles.tdNoInfo} style={{ paddingBottom: '15px' }}>
                  No information on record.
                </td>
              </tr>
              : rowData.map((row, rowIndex) => (
                <tr
                  key={rowIndex}
                  className={rowClasses}
                  style={{ background: "white" }}
                >
                  <td
                    // key={cellIndex}
                    style={{ fontFamily: "'PT Sans', sans-serif", width: "5%" }}
                    className={styles.td}
                  >
                    <div>
                      <Checkbox
                        disabled={disabled}
                        checked={row.default}
                        icon={<RadioButtonUncheckedIcon />}
                        checkedIcon={<CheckCircleOutlineIcon />}
                        style={{ pl: 20 }}
                        onChange={(e) =>
                          handleRowUpdate("default", row, !row.isSelected)
                        }
                      />
                    </div>
                  </td>
                  <td
                    // key={cellIndex}
                    style={{ fontFamily: "'PT Sans', sans-serif", width: "10%" }}
                    className={styles.td}
                  >
                    <div>{row.name}</div>
                  </td>

                  <td
                    // key={cellIndex}
                    style={{ fontFamily: "'PT Sans', sans-serif", width: "10%" }}
                    className={styles.td}
                  >
                    <div className={styles.CenterContent}>{row.clientType || '--'}</div>
                  </td>

                  <td
                    // key={cellIndex}
                    style={{ fontFamily: "'PT Sans', sans-serif", width: "15%" }}
                    className={styles.td}
                  >
                    <div className={styles.CenterContent}>{row.email}</div>
                  </td>
                  <td
                    // key={cellIndex}
                    style={{ fontFamily: "'PT Sans', sans-serif", width: "60%" }}
                    className={styles.td}
                  >
                    <div className={styles.CenterContent}>{row.address}</div>
                  </td>
                </tr>
              ))}
        </tbody>
      </table>
    </div>
  );
};

export default BillPayerTable;
